'use client';

import { Avatar, Button } from '@pickleballinc/react-ui';

import { SearchNewPlayer } from '@/modules/league/new-components/types';

interface PlayerSearchCardProps {
  players: SearchNewPlayer[];
  handleAddPlayer: (player: SearchNewPlayer) => void;
}

export default function PlayerSearchCard({ players, handleAddPlayer }: PlayerSearchCardProps) {
  return (
    players && (
      <div className='mb-16 flex flex-col gap-2'>
        {players.map((player) => (
          <div
            key={`player-card-${player.UserID}`}
            className='rounded-lg border border-leagues-300/50 bg-leagues-300/5 text-start text-sm shadow-md hover:border-gray-300'
          >
            <div className='flex w-full flex-row items-center justify-between p-4 '>
              <div className='flex gap-6'>
                <div className='flex flex-col items-center text-xs'>
                  <Avatar size='xl' imageUrl={undefined} />
                </div>
                <div className='flex flex-col gap-1 text-xs'>
                  <p className='text-base font-semibold text-gray-900'>
                    {player.FirstName} {player.LastName}
                  </p>
                  <p>
                    Age: {player.Age} | {player.Gender === 'F' ? 'Female' : 'Male'}
                  </p>
                  <p>{player.Email}</p>
                  <p>
                    {player.Phone_CallingCode} {player.Phone}
                  </p>
                  <div className='flex gap-1'>
                    <p>Rating {player.Rating ? player.Rating : 'NR'}</p>
                  </div>
                </div>
              </div>
              {!player.errorMessage && (
                <Button
                  className='w-fit self-end !bg-leagues-300'
                  size='xs'
                  variant='primary'
                  onClick={() => handleAddPlayer(player)}
                >
                  <p className='text-xs font-semibold text-white'>Select</p>
                </Button>
              )}
            </div>
            {player.errorMessage && (
              <div className='rounded-b-lg bg-error-50 py-1.5 text-center text-xs font-medium text-error-700'>
                {player.errorMessage}
              </div>
            )}
          </div>
        ))}
      </div>
    )
  );
}
